import _ from "lodash";
import {
  Component,
} from "react";
import {
  Alert,
  Button,
  Modal,
  Table,
} from "react-bootstrap";

import nutzerApi from "Apis/nutzer-api";
import apifetch from "CommonCore/apifetch";
import {
  formatDate,
  formatDateTime,
} from "CommonCore/l10n";
import {
  ChangeOnTypeFormControl,
  DetailView,
} from "CommonComponents/detail-view";
import {
  EditPanel,
  Panel,
  Pill,
  Spinner,
} from "CommonComponents/bricks";
import store from "CommonState/store";
import uiconfig, {
  ifAllowed,
  ifValidEntity,
} from "CommonState/uiconfig";
import {
  createListPageConnector,
  createDetailTabViewConnector,
  createDetailEditorConnector,
} from "CommonComponents/page-factories";

/*
 *import {
 *    NutzerRechteTab,
 *    NutzerRechteAddWindow,
 *} from 'App/nutzer-rechte-tab'
 */
const AktivPill = ({ aktiv, className }) => <div className={className}><Pill variant={aktiv ? "success" : "default"}>{aktiv ? "Aktiv" : "Inaktiv"}</Pill></div>;

const DetailRenderMethods = {
    /*
     *rechte: {
     *    inject: ['einrichtungLookup', 'lehreinheitLookup', 'rolleList'],
     *    generator: (einrichtungLookup, lehreinheitLookup, rolleList) => rechte =>
     *        (rechte||[]).map((re, i) => {
     *            let rolle = _.get(_.find(rolleList, r => r.id === re.rolle), 'bez');
     *            let einrichtung = re.einrichtung && _.get(einrichtungLookup, [re.einrichtung, 'kbez']);
     *            let lehreinheit = re.lehreinheit && _.get(lehreinheitLookup, [re.lehreinheit, 'leh_kbez']);
     *            let assoc = lehreinheit || einrichtung;
     *            return <div key={i}>{rolle}{assoc && `: ${assoc}`}</div>}
     *        ),
     *},
     */
  l_letzte_login: wert => wert && formatDateTime(wert),
  l_login: (l_login, entity) => (entity && entity.l_lokal ? `${l_login} (lokal)` : l_login),
  l_aktiv: l_aktiv => <AktivPill aktiv={l_aktiv} />,
  l_gesperrt: (l_gesperrt, entity) => (l_gesperrt ? `Ja (${entity.l_anzfehllogin})` : "Nein"),
};

const TableRenderMethods = _.assign({}, DetailRenderMethods, {
  aktiv: aktiv => <AktivPill aktiv={aktiv} className='text-center' />,
});

const schemaNutzerdaten = {
  displayName: "Nutzerdaten",
  table: nutzerApi.schema.table.filter(f => !f.field.startsWith("l_") && f.field !== "n_email"),
};

const schemaLogindaten = {
  displayName: "Login-Daten",
  table: nutzerApi.schema.table.filter(f => ["l_login", "l_letzte_login", "l_aktiv", "l_gesperrt"].includes(f.field)),
};

@uiconfig
@store()
@nutzerApi.current
@nutzerApi.actions
@ifAllowed(`page.${ nutzerApi.names.name }`)
@ifValidEntity(nutzerApi.names.currentName)
class NutzerDetailView extends Component {
  render() {
    const entity = this.props[nutzerApi.names.currentName];
    if (!entity) {
      return <Spinner />;
    }
    return <div>
      <EditPanel
        header={<h4>Nutzerdaten</h4>}
        editable
        schema={schemaNutzerdaten}
        entity={entity}
        onSave={this.saveNutzerdaten}
      />
      <div className='box-panel'>
        <Panel header={<h4>Login-Daten</h4>}>
          <DetailView
            schema={schemaLogindaten}
            entity={entity}
            renderMethods={DetailRenderMethods}
          />
        </Panel>
      </div>
    </div>;
  }

  saveNutzerdaten = async(entity, toggleEditMode) => {
    await this.props[nutzerApi.names.saveActionName](entity);
    toggleEditMode();
  };
}

@nutzerApi.current
class NutzerAntraegeTab extends Component {
  constructor() {
    super();
    this.state = {
      antraege: null,
      loading: false,
      error: null,
    };
  }

  componentDidMount() {
    const entity = this.props[nutzerApi.names.currentName];
    if (entity) {
      this.loadAntraege(entity.n_id);
    }
  }

  componentDidUpdate(prevProps) {
    const entity = this.props[nutzerApi.names.currentName];
    const prevEntity = prevProps[nutzerApi.names.currentName];
    if (entity && entity.n_id !== (prevEntity && prevEntity.n_id)) {
      this.loadAntraege(entity.n_id);
    }
  }

  loadAntraege = async nid => {
    this.setState({ loading: true, error: null });
    try {
      const result = await apifetch(`/api/shknutzer/admin/${ nid }/antraege`);
      this.setState({ antraege: result.data, loading: false });
    } catch(err) {
      this.setState({
        error: "Die Anträge konnten nicht geladen werden.",
        loading: false,
      });
    }
  };

  render() {
    const { antraege, loading, error } = this.state;

    if (loading || antraege === null) {
      return <Spinner />;
    }

    if (error) {
      return <Alert variant='danger'>{error}</Alert>;
    }

    return <div className='box-panel'>
      <Panel header={<h4>Anträge</h4>}>
        {antraege.length === 0
          ? <p>Keine Anträge vorhanden.</p>
          : <Table striped hover size='sm'>
            <thead>
              <tr>
                <th>Antragsnummer</th>
                <th>Antragstyp</th>
                <th>Vertragsart</th>
                <th>Eingangsdatum</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {antraege.map(a => (
                <tr key={a.a_id}>
                  <td>{a.a_nr}</td>
                  <td>{a.a_antragstyp}</td>
                  <td>{a.a_vertragsart}</td>
                  <td>{formatDate(a.a_eingangsdat)}</td>
                  <td>{a.a_status}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        }
      </Panel>
    </div>;
  }
}

@nutzerApi.current
class NutzerMassnahmenTab extends Component {
  constructor() {
    super();
    this.state = {
      massnahmen: null,
      loading: false,
      error: null,
    };
  }

  componentDidMount() {
    const entity = this.props[nutzerApi.names.currentName];
    if (entity) {
      this.loadMassnahmen(entity.n_id);
    }
  }

  componentDidUpdate(prevProps) {
    const entity = this.props[nutzerApi.names.currentName];
    const prevEntity = prevProps[nutzerApi.names.currentName];
    if (entity && entity.n_id !== (prevEntity && prevEntity.n_id)) {
      this.loadMassnahmen(entity.n_id);
    }
  }

  loadMassnahmen = async nid => {
    this.setState({ loading: true, error: null });
    try {
      const result = await apifetch(`/api/shknutzer/admin/${ nid }/massnahmen`);
      this.setState({ massnahmen: result.data, loading: false });
    } catch(err) {
      this.setState({
        error: "Die Maßnahmen konnten nicht geladen werden.",
        loading: false,
      });
    }
  };

  render() {
    const { massnahmen, loading, error } = this.state;

    if (loading || massnahmen === null) {
      return <Spinner />;
    }

    if (error) {
      return <Alert variant='danger'>{error}</Alert>;
    }

    return <div className='box-panel'>
      <Panel header={<h4>Maßnahmen</h4>}>
        {massnahmen.length === 0
          ? <p>Keine Maßnahmen vorhanden.</p>
          : <Table striped hover size='sm'>
            <thead>
              <tr>
                <th>PBP-Nr.</th>
                <th>Vorgesehen</th>
                <th>Name</th>
                <th>Bezeichnung</th>
                <th>Gültig ab</th>
                <th>Gültig bis</th>
                <th>Vertragsart</th>
              </tr>
            </thead>
            <tbody>
              {massnahmen.map((m, i) => (
                <tr key={i}>
                  <td>{m.m_pbpid_display}</td>
                  <td>{m.m_vorgesehen}</td>
                  <td>{m.m_name}</td>
                  <td>{m.m_bez}</td>
                  <td>{formatDate(m.m_gueltigab)}</td>
                  <td>{formatDate(m.m_gueltigbis)}</td>
                  <td>{m.art_kbez}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        }
      </Panel>
    </div>;
  }
}

@nutzerApi.actions
class NutzerLoginEmailAendernPopup extends Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    const { item } = this.props;
    this.setState({ n_email: (item && (item.n_email || item.l_login)) || "" });
  }

  render() {
    const { onClose, item } = this.props;
    const { errorMessage, inflight, n_email } = this.state;

    return <Modal show onHide={onClose}>
      <Modal.Header>
        Login/E-Mail ändern
      </Modal.Header>
      <Modal.Body>
        {errorMessage && <Alert variant='danger'>{errorMessage}</Alert>}
        <p>{`Bitte neue Login/E-Mail für ${ item.n_vorname } ${ item.n_name } angeben.`}</p>
        <ChangeOnTypeFormControl
          id='nutzer-login-email'
          entity={this.state}
          schema={{ field: "n_email", display: "Neue E-Mail", maxlength: 255 }}
          onChange={this.onChange}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant='primary' onClick={this.onConfirm} disabled={inflight || _.isEmpty((n_email || "").trim())}>
          Speichern
        </Button>
        <Button variant='link' onClick={onClose} disabled={inflight}>
          Abbrechen
        </Button>
      </Modal.Footer>
    </Modal>;
  }

  onChange = (schemaOrField, value) => {
    const field = _.isString(schemaOrField) ? schemaOrField : schemaOrField.field;
    this.setState({ [field]: value });
  };

  onConfirm = async() => {
    const { item, onClose } = this.props;
    const email = (this.state.n_email || "").trim();
    if (!email) {
      this.setState({ errorMessage: "Neue E-Mail muss angegeben werden" });
      return;
    }

    this.setState({ inflight: true, errorMessage: null });
    try {
      await apifetch(`/api/shknutzer/admin/login-email/${ item.n_id }`, {
        method: "PUT",
        body: { email },
      });
      await this.props.refreshNutzerInStore(item.n_id);
      onClose();
    } catch(err) {
      this.setState({
        errorMessage:
          (err.response && (err.response.nachricht || err.response.um))
          || "Es ist ein Fehler aufgetreten.",
        inflight: false,
      });
    }
  };
}

@nutzerApi.actions
class NutzerLoginAendernPopup extends Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    const { item } = this.props;
    this.setState({ l_login: (item && item.l_login) || "" });
  }

  render() {
    const { onClose, item } = this.props;
    const { errorMessage, inflight, l_login } = this.state;

    return <Modal show onHide={onClose}>
      <Modal.Header>
        Login ändern
      </Modal.Header>
      <Modal.Body>
        {errorMessage && <Alert variant='danger'>{errorMessage}</Alert>}
        <p>{`Bitte neuen Login für ${ item.n_vorname } ${ item.n_name } angeben.`}</p>
        <ChangeOnTypeFormControl
          id='nutzer-login'
          entity={this.state}
          schema={{ field: "l_login", display: "Neuer Login", maxlength: 255 }}
          onChange={this.onChange}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant='primary' onClick={this.onConfirm} disabled={inflight || _.isEmpty((l_login || "").trim())}>
          Speichern
        </Button>
        <Button variant='link' onClick={onClose} disabled={inflight}>
          Abbrechen
        </Button>
      </Modal.Footer>
    </Modal>;
  }

  onChange = (schemaOrField, value) => {
    const field = _.isString(schemaOrField) ? schemaOrField : schemaOrField.field;
    this.setState({ [field]: value });
  };

  onConfirm = async() => {
    const { item, onClose } = this.props;
    const login = (this.state.l_login || "").trim();
    if (!login) {
      this.setState({ errorMessage: "Neuer Login muss angegeben werden" });
      return;
    }

    this.setState({ inflight: true, errorMessage: null });
    try {
      await apifetch(`/api/shknutzer/admin/login/${ item.n_id }`, {
        method: "PUT",
        body: { login },
      });
      await this.props.refreshNutzerInStore(item.n_id);
      onClose();
    } catch(err) {
      this.setState({
        errorMessage:
          (err.response && (err.response.nachricht || err.response.um))
          || "Es ist ein Fehler aufgetreten.",
        inflight: false,
      });
    }
  };
}

@nutzerApi.actions
class NutzerEmailAendernPopup extends Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    const { item } = this.props;
    this.setState({ n_email: (item && item.n_email) || "" });
  }

  render() {
    const { onClose, item } = this.props;
    const { errorMessage, inflight, n_email } = this.state;

    return <Modal show onHide={onClose}>
      <Modal.Header>
        E-Mail ändern
      </Modal.Header>
      <Modal.Body>
        {errorMessage && <Alert variant='danger'>{errorMessage}</Alert>}
        <p>{`Bitte neue E-Mail für ${ item.n_vorname } ${ item.n_name } angeben.`}</p>
        <ChangeOnTypeFormControl
          id='nutzer-email'
          entity={this.state}
          schema={{ field: "n_email", display: "Neue E-Mail", maxlength: 255 }}
          onChange={this.onChange}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant='primary' onClick={this.onConfirm} disabled={inflight || _.isEmpty((n_email || "").trim())}>
          Speichern
        </Button>
        <Button variant='link' onClick={onClose} disabled={inflight}>
          Abbrechen
        </Button>
      </Modal.Footer>
    </Modal>;
  }

  onChange = (schemaOrField, value) => {
    const field = _.isString(schemaOrField) ? schemaOrField : schemaOrField.field;
    this.setState({ [field]: value });
  };

  onConfirm = async() => {
    const { item, onClose } = this.props;
    const email = (this.state.n_email || "").trim();
    if (!email) {
      this.setState({ errorMessage: "Neue E-Mail muss angegeben werden" });
      return;
    }

    this.setState({ inflight: true, errorMessage: null });
    try {
      await apifetch(`/api/shknutzer/admin/email/${ item.n_id }`, {
        method: "PUT",
        body: { email },
      });
      await this.props.refreshNutzerInStore(item.n_id);
      onClose();
    } catch(err) {
      this.setState({
        errorMessage:
          (err.response && (err.response.nachricht || err.response.um))
          || "Es ist ein Fehler aufgetreten.",
        inflight: false,
      });
    }
  };
}

@nutzerApi.actions
class NutzerEntsperrenPopup extends Component {
  constructor() {
    super();
    this.state = {
      inflight: false,
      errorMessage: null,
    };
  }

  render() {
    const { onClose, item } = this.props;
    const { inflight, errorMessage } = this.state;

    return <Modal show onHide={onClose}>
      <Modal.Header>
        Nutzer entsperren
      </Modal.Header>
      <Modal.Body>
        {errorMessage && <Alert variant='danger'>{errorMessage}</Alert>}
        <p>{`Soll ${ item.n_vorname } ${ item.n_name } entsperrt werden?`}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='primary' onClick={this.onConfirm} disabled={inflight}>
          Entsperren
        </Button>
        <Button variant='link' onClick={onClose} disabled={inflight}>
          Abbrechen
        </Button>
      </Modal.Footer>
    </Modal>;
  }

  onConfirm = async() => {
    const { item, onClose } = this.props;

    this.setState({ inflight: true, errorMessage: null });
    try {
      await apifetch(`/api/shknutzer/admin/gesperrt/${ item.n_id }`, {
        method: "PUT",
        body: { l_gesperrt: false },
      });
      await this.props.refreshNutzerInStore(item.n_id);
      onClose();
    } catch(err) {
      this.setState({
        errorMessage:
          (err.response && (err.response.nachricht || err.response.um))
          || "Es ist ein Fehler aufgetreten.",
        inflight: false,
      });
    }
  };
}

@nutzerApi.actions
class NutzerAktivierenDeaktivierenPopup extends Component {
  constructor() {
    super();
    this.state = {
      inflight: false,
      errorMessage: null,
    };
  }

  render() {
    const { onClose, item } = this.props;
    const { inflight, errorMessage } = this.state;
    const aktion = item.l_aktiv ? "deaktiviert" : "aktiviert";

    return <Modal show onHide={onClose}>
      <Modal.Header>
        Aktivieren/Deaktivieren
      </Modal.Header>
      <Modal.Body>
        {errorMessage && <Alert variant='danger'>{errorMessage}</Alert>}
        <p>{`Soll ${ item.n_vorname } ${ item.n_name } ${aktion} werden?`}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='primary' onClick={this.onConfirm} disabled={inflight}>
          Bestätigen
        </Button>
        <Button variant='link' onClick={onClose} disabled={inflight}>
          Abbrechen
        </Button>
      </Modal.Footer>
    </Modal>;
  }

  onConfirm = async() => {
    const { item, onClose } = this.props;

    this.setState({ inflight: true, errorMessage: null });
    try {
      await apifetch(`/api/shknutzer/admin/aktiv/${ item.n_id }`, {
        method: "PUT",
      });
      await this.props.refreshNutzerInStore(item.n_id);
      onClose();
    } catch(err) {
      this.setState({
        errorMessage:
          (err.response && (err.response.nachricht || err.response.um))
          || "Es ist ein Fehler aufgetreten.",
        inflight: false,
      });
    }
  };
}

nutzerApi.registerRoutes({
  list: createListPageConnector({
    api: nutzerApi,
    renderMethods: TableRenderMethods,
    fieldToDetailLink: "n_email",
    perRowActions: true,
    extraActions: (_nutzer, actions) => {
      actions.splice(1, 0, {
        display: "Login/E-Mail ändern",
        icon: "envelope",
        component: NutzerLoginEmailAendernPopup,
      });
      actions.splice(2, 0, {
        display: "Login ändern",
        icon: "user",
        component: NutzerLoginAendernPopup,
      });
      actions.splice(3, 0, {
        display: "E-Mail ändern",
        icon: "at",
        component: NutzerEmailAendernPopup,
      });
      actions.splice(4, 0, {
        display: "Entsperren",
        icon: "unlock",
        component: NutzerEntsperrenPopup,
      });
      actions.splice(5, 0, {
        display: "Aktivieren/Deaktivieren",
        icon: "power-off",
        component: NutzerAktivierenDeaktivierenPopup,
      });
    },

        /*
         *extraActions: (nutzer, actions) => {
         *  let z = nutzer.zugriff;
         *  actions.splice(3, 0, {
         *      display: z && z.darfRechteBearbeiten ? 'Rechte bearbeiten' : 'Rechte anzeigen',
         *      icon: 'cogs',
         *      execute: nutzer => `/nutzer/${nutzer.id}/rechte`,
         *  })
         *}
         */
  }),

  detailTabs: createDetailTabViewConnector({
    api: nutzerApi,
    extra: [
      { path: "antraege", header: "Anträge" },
      { path: "massnahmen", header: "Maßnahmen" },
    ],
  }),

  detailView: NutzerDetailView,
  detailEdit: createDetailEditorConnector({ api: nutzerApi }),

  detailExtra: [
    { path: "antraege", component: NutzerAntraegeTab },
    { path: "massnahmen", component: NutzerMassnahmenTab },
  ],

/*
 *Ü
 *  detailExtra: [
 *      {
 *          path: 'rechte',
 *          component: NutzerRechteTab,
 *          childRoutes: [
 *              {
 *                  path: 'neu',
 *                  component: NutzerRechteAddWindow
 *              }
 *          ]
 *      }
 *  ]
 */
});
